export const PRICE_CHECK = 'src/components/Klarna/PRICE_CHECK'
export const START_KLARNA = 'src/components/Klarna/START_KLARNA'
export const KLARNA_FAILURE = 'src/components/Klarna/KLARNA_FAILURE'
